export default "__VITE_ASSET__CGVaZLab__"